import { Mail, MapPin, Facebook, Instagram, Music2, Youtube, Twitch } from "lucide-react";
import { IMG, CONTACT_EMAIL, SOCIALS } from "@/lib/assets";

const ICONS = { Facebook, Instagram, TikTok: Music2, Twitch, YouTube: Youtube };

export default function Contatti() {
  return (
    <div className="text-white">
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: `url(${IMG.militaryBg})`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 to-[#050507]" />
        <div className="absolute inset-0 grid-overlay-gold opacity-30" />
        <div className="relative max-w-4xl mx-auto px-5 text-center">
          <h1 className="heading text-6xl sm:text-7xl">CON<span className="gold-text">TATTI</span></h1>
          <p className="font-rajdhani text-gray-300 text-lg mt-4">Mettiti in contatto con lo staff di Seals e Seals Allies Force.</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-5 py-16 space-y-14">
        {/* EMAIL */}
        <section className="panel panel-gold clip-beveled p-8 md:p-10 text-center" data-testid="contact-email">
          <Mail className="w-12 h-12 text-[var(--gold)] mx-auto mb-4" strokeWidth={1.5} />
          <h2 className="heading text-3xl text-white">Scrivi agli Admin</h2>
          <p className="font-rajdhani text-gray-400 mt-2">Per informazioni sui tornei, l'alleanza o la community, contatta lo staff via email:</p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-mailto"
            className="btn-gold clip-beveled inline-flex items-center gap-2 px-8 py-3 mt-5 text-base">
            <Mail className="w-4 h-4" /> {CONTACT_EMAIL}
          </a>
        </section>

        {/* SOCIAL */}
        <section data-testid="socials">
          <h2 className="heading text-3xl gold-text text-center mb-8">Seguici</h2>
          <div className="grid md:grid-cols-2 gap-8">
            {[{ key: "seals", title: "SEALS", list: SOCIALS.seals }, { key: "saf", title: "S.A.F.", list: SOCIALS.saf }].map((grp) => (
              <div key={grp.key} className="panel panel-gold clip-beveled p-6" data-testid={`socials-${grp.key}`}>
                <h3 className="heading text-2xl text-white text-center mb-4">{grp.title}</h3>
                <div className="flex flex-wrap justify-center gap-3">
                  {grp.list.map((s) => {
                    const Ic = ICONS[s.label] || Mail;
                    return (
                      <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer"
                        data-testid={`social-${grp.key}-${s.label.toLowerCase()}`}
                        className="flex items-center gap-2 panel clip-beveled-sm px-4 py-2 hover:panel-gold transition-colors">
                        <Ic className="w-5 h-5 text-[var(--gold)]" strokeWidth={1.5} />
                        <span className="font-rajdhani text-white text-sm">{s.label}</span>
                      </a>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* VIENI A TROVARCI */}
        <section data-testid="contact-maps">
          <div className="text-center mb-8">
            <MapPin className="w-10 h-10 text-[var(--gold)] mx-auto mb-2" strokeWidth={1.5} />
            <h2 className="heading text-4xl gold-text">Vieni a Trovarci Qui</h2>
            <p className="font-rajdhani text-gray-400 mt-2">I nostri campi di battaglia preferiti su Call of Duty: Warzone.</p>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {[{ img: IMG.mapVerdansk, name: "Verdansk" }, { img: IMG.mapRebirth, name: "Rebirth Island" }].map((m) => (
              <div key={m.name} className="panel panel-gold clip-beveled overflow-hidden group">
                <div className="relative h-64 overflow-hidden">
                  <img src={m.img} alt={m.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                  <div className="absolute bottom-4 left-5">
                    <span className="font-rajdhani uppercase tracking-[0.3em] text-[var(--gold-light)] text-xs">Mappa</span>
                    <h3 className="heading text-4xl text-white">{m.name}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
